import { BrowserError } from '@/components/BrowserError/BrowserError';
import { useConfig } from '@/hooks/useConfig/useConfig';
import { useAirKeyTracePageView } from '@/utils/airKeyTrace';

// TODO: Add analytics for 'Copy Link' button
// TODO: Can we simplify BrowserNotSupport and SafariRequired pages? Are they both needed?
export const SafariRequired = ({ link }: { link: string }) => {
  const { content, locale } = useConfig();
  useAirKeyTracePageView('safari_required');
  return (
    <BrowserError
      title={content.safariRequired.title[locale]}
      body={content.safariRequired.description[locale]}
      link={link}
    />
  );
};
